<template>
  <div v-if="routerName" class="card-box">
    <router-link :to="{ name: routerName }" :target="target" class="-anchor">
      <slot></slot>
    </router-link>
  </div>
  <div v-else-if="href" class="card-box">
    <a :href="href" :target="target" class="btn-main">
      <slot></slot>
    </a>
  </div>
  <div v-else class="card-box">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "CardBox",
  props: {
    variant: { type: String, default: "" },
    routerName: { type: String, default: "" },
    target: { type: String, default: "" },
    href: { type: String, default: "" },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.card-box {
  border: 1px solid #cccccc;
  border-radius: 10px;
  &.-margin-md {
    margin-bottom: 40px;
    @include mq-up(md) {
      margin-bottom: 60px;
    }
  }
  > .-anchor:hover {
    text-decoration: underline;
  }
  :deep(.collapse) {
    > .body {
      padding-right: 30px;
      padding-left: 30px;
      @include mq-down(md) {
        padding-right: 15px;
        padding-left: 15px;
      }
      .text {
        margin-top: 30px;
        margin-bottom: 30px;
        @include mq-down(md) {
          margin-top: 15px;
          margin-bottom: 15px;
        }
      }
    }
  }
  :deep(.card-header) + .card-body {
    padding-top: 0px;
  }
  &.-alert {
    border: none;
    text-align: center;
    :deep(.card-header) {
      padding-bottom: 10px;
      font-size: 24px;
      line-height: 32px;
    }
  }
  &.-success {
    background-color: $success;
    :deep(.card-header) {
      color: $primary;
    }
  }
  &.-cancel {
    background-color: $light;
    :deep(.card-header) {
      color: $black;
    }
  }
  &.-error {
    background-color: $warning;
    :deep(.card-header) {
      color: $danger;
    }
  }
  &.-link {
    &:hover {
      //border-color: $primary;
    }
  }
  &.-image-top {
    border: none;
    border-radius: 0px;
  }
  &.-faq,
  &.-contact {
    @include mq-down(md) {
      margin: 0 -20px;
      border: none;
      border-radius: 0px;
    }
    :deep(.card-header) {
      background: $primary;
      text-align: center;
      color: $white;
      font-weight: normal;
      @include mq-down(md) {
        border-radius: 0px;
        font-size: 18px;
      }
      @include mq-up(md) {
        font-size: 24px;
      }
      & + .card-body {
        padding-top: 20px;
        @include mq-up() {
          padding-top: 30px;
        }
      }
    }
  }
  &.-flex {
    > .-anchor {
      @include mq-down(md) {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        background-image: url("@/assets/images/icons/arrow-right-gray.svg");
        background-position: right 0px center;
        background-repeat: no-repeat;
        background-size: 8px auto;
      }
    }
  }
}
</style>
